<template>
    <div>
        <div class="page-title">Template Manage</div>
        <div class="page-box">
            <div class="page-button"> 
                  <el-button icon="el-icon-plus" @click="onAdd" type="warning"> Add </el-button>
            </div>
            <el-table
                :data="templates"
                style="width: 100%;">
                    <el-table-column
                        prop="title"
                        label="Template">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="Template Type">
                        <template slot-scope="{row}">
                               <span>{{row.type | TemplateType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Action">
                        <template slot-scope="{row}">
                            <el-button type="text" @click="onView(row.id)">View</el-button>
                            <el-button type="text" @click="onEdit(row.id)">Edit</el-button>
                            <el-button type="text" @click="onSend(row.id)">Send</el-button>
                            <el-button v-if="row.type == 0" type="text" @click="onDelete(row.id)">Delete</el-button>
                        </template>
                    </el-table-column>
            </el-table>
        </div>
        <loadingSlotDialog :centerDialogVisible="centerDialogVisible" @close="close">
            <img src="@/assets/images/feather-alert-circle.png"/>
            <div class="dialog-text">Are you sure to delete this item ?</div>
             <el-button @click="onConfirm" type="danger">Confirm</el-button>
             <el-button @click="onCancel">Cancel</el-button>
        </loadingSlotDialog>
    </div>
</template>

<script>
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import {getTemplates,deleteTemplates} from '@/api/admin/notification'
    export default {
        components:{loadingSlotDialog},
        props:{
          formType:{
            type:Number,
            default:0
          },
          
        },
        filters:{
            TemplateType(v){
                switch (v) {
                    case 0:
                        return 'Other template'
                    case 1:
                        return 'Status template'
                }
            }
        },
        data() {
            return {
                centerDialogVisible:false,
                templates: [],
                itemId:0
            }
        },
        watch:{
            formType:{
                handler(){
                    this.getTemplates()
                },
                deep:true,
                immediate:true
            }
        },
        methods:{
            onConfirm(){
                this.deleteTemplates()
            },
            close(){
                this.centerDialogVisible = false
            },
            onCancel(){
                this.centerDialogVisible = false
            },
            onAdd(){
               this.$router.push({name:'addTemplateManage',params:{formType:this.formType}})
            },
            onView(id){
                this.$router.push({path:`/admin/templateDetail/${id}`})
            },
            onEdit(id){
                this.$router.push({path:`/admin/templateManage/${id}/edit`})
            },
            onSend(id){
                this.$router.push({path:`/admin/templateManage/${id}/sendTemplate/${this.formType}`})
            },
            onDelete(id){
                this.itemId = id
                this.centerDialogVisible = true
            },
            deleteTemplates(){
                deleteTemplates(this.itemId).then(()=>{
                    this.getTemplates()
                }).finally(()=>{
                     this.centerDialogVisible = false
                })
            },
            getTemplates(){
                let from = {
                    formType:this.formType
                }
                getTemplates(from).then((v)=>{
                    this.templates = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    padding-top: 20px;
    background-color: #fff;
    min-height: 100vh;
    margin-bottom: 20px;
}
.page-button{
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
}
.dialog-text{
    font-size: 36px;
    color: #272727;
}
</style>